import { render, staticRenderFns } from "./theclassList.vue?vue&type=template&id=61f741ae&scoped=true"
import script from "./theclassList.vue?vue&type=script&lang=js"
export * from "./theclassList.vue?vue&type=script&lang=js"
import style0 from "./theclassList.vue?vue&type=style&index=0&id=61f741ae&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f741ae",
  null
  
)

export default component.exports